<div class="message-box">
    <h3>✅ Success!</h3>
    <p>Your file has been downloaded successfully.</p>
</div>